<template>
    <div 
        class="Mcp-ResumePage"
        :class="{recomandationPage: !diagnosticComponent}"
    >
        <!-- Tab content -->
        <TabSteps
            v-if="displayStepsTab"
        />

        <DiagnosticResume
            v-if="diagnosticComponent"
            :dwellingResumeDatas="dwellingResumeDatas"
            @diagnosticResume::goNextPage="displayDiagnosticComponent(false)"
            @diagnosticResume::goPrevPage="backToLeadForm"
        />

        <RecomendationResume
            v-if="!diagnosticComponent"
            :key="currentStep"
            :currentStep="currentStep"
            @goBack::display-diagnostic="displayDiagnosticComponent(true)"
            @goBack::display-tunnel="backToTunnelForm"
            @stepsTab::hide="hideStepTab"
        />

    </div>
</template>

<script>
import DiagnosticResume from '@/includes/Simulator/ResumePages/DiagnosticResume.vue';
import RecomendationResume from '@/includes/Simulator/ResumePages/RecomendationResume.vue';
import TabSteps from '@/includes/Simulator/ActionsComponents/TabSteps.vue';


import EventBus from "@/event-bus";
import { mapGetters } from "vuex";


export default {
    name: "ResumeSimulatorPage",

    components: {
        DiagnosticResume,
        RecomendationResume,
        TabSteps
    },

    computed: {
        ...mapGetters({ 
            dwellingResumeDatas: "getDwellingStepResume",
            currentStep: "getCurrentStep",
            previousQuestion: "getPreviousQuestion"

        }),
    },

    data() {
        return {
            diagnosticComponent: false,
            displayStepsTab: true
        };
    },

    methods: {
        /**
         * Toggle Diagnostic/Economy component
         */
        displayDiagnosticComponent(value) {
            this.diagnosticComponent = value;
        },

        /**
         * go back to lead form
         */
        backToLeadForm() {
            this.$emit('backToLeadStep::ResumePage')
        },

        /**
         * backToTunnelForm
         */
        backToTunnelForm() {
            EventBus.$emit('simulator-page::tunnel', this.previousQuestion.form, this.previousQuestion.index)
        },

        hideStepTab() {
            this.displayStepsTab = false;
        }
    },

    mounted() {
        //Display diagnostic only after step 1
        this.displayDiagnosticComponent(this.currentStep == "save_energy");
    },
    
    
}
</script>

<style lang="scss" >
    .Mcp-ResumePage {
        padding: 0 20px;

        &.recomandationPage {
            .Mcp-SimulatorSteps {
                display: none;

                @include breakpoint(md) {
                    display: block;
                }
            }
        }
    }
</style>